import { Injectable } from '@angular/core';
import { LstorageService } from './../services/lstorage.service';

export const darkTheme = {
  'bg-color': '#252935',
  'logo-color': '#b6b8bb',
  logocolor1: '#ffffff',
  themecolor: '#02c0ce',
  'textcolor-dark': '#fff',
  textcolor: '#ffffff',
  textcolor2: '#8f9ea5',
  textcolor4: '#b5c6cc',
  'textcolor-light30': '#b5c6cc',
  'textcolor-light60': '#b5c6cc',
  'textcolor-light90': '#b5c6cc',
  'light-color': '#b3b3b3',
  linkcolor: '#b5c6cc',
  'textcolor-lightfull': '#252935',
  lightbg: '#2d3744',
  'loginbbox-color': 'rgba(0, 0, 0, 0.3)',
  lightbg1: '#313a46',
  lightbg2: '#37414f',

  'light-full': '#3e4755',
  'border-color': '#424e5e',
  'breadcrumb-color': '#2d3744',
  'header-gradient': ' linear-gradient(to top, #02c0ce 0%, #02c0ce)',
  'button-gradient': 'linear-gradient(33deg, #02c0ce, #02c0ce)',
  'theme-boxshadow': '0px 3px 8px 0 rgba(2, 192, 206, 0.32)',
  'bg1-color': '#404956',
  textboxbg: '#2e323d',
};

export const lightTheme = {
  'bg-color': '#f4f4f4',
  'logo-color': '#02c0ce',
  logocolor1: '#02c0ce',
  themecolor: '#02c0ce',
  textcolor: '#ffffff',
  textcolor2: '#999999',
  textcolor4: '#5a5a5a',
  'textcolor-dark': '#000',
  'textcolor-light30': '#333333',
  'textcolor-light60': '#666666',
  'textcolor-light90': '#999999',
  'light-color': '#b3b3b3',
  linkcolor: '#098ac1',
  'textcolor-lightfull': '#fff',
  lightbg: '#f6f9fb',
  lightbg1: '#fefefe',
  lightbg2: '#ffffff',
  'loginbbox-color': 'rgb(255, 255, 255)',
  'light-full': '#fff',
  'border-color': '#e3e3e3',
  'breadcrumb-color': '#ececec',
  'header-gradient': ' linear-gradient(to top, #02c0ce 0%, #02c0ce)',
  //'button-gradient':'linear-gradient(33deg, #e85242, #ff7363)',
  'theme-boxshadow': '0px 3px 8px 0 rgba(251, 103, 87, 0.45)',
  'bg1-color': '#eeeeee',
};

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(private token: LstorageService) {
    if (token.getTheme()) {
      // alert("theme ftrom token");
      this.setTheme(token.getTheme());
    } else {
      this.setTheme(darkTheme);
    }
  }
  toggleDark() {
    this.token.saveTheme(darkTheme);
    this.setTheme(darkTheme);
  }

  toggleLight() {
    this.token.saveTheme(lightTheme);
    this.setTheme(lightTheme);
  }

  private setTheme(theme: {}) {
    // alert("theme setting");
    Object.keys(theme).forEach((k) =>
      document.documentElement.style.setProperty(`--${k}`, theme[k])
    );
  }
}
